/*
 * File: ModalHeader.tsx
 * Project: meki
 * File Created: Wednesday, 8th February 2023 11:45:16 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Wednesday, 8th February 2023 11:45:27 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2023 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import React from 'react';
import { IconButton } from '@mui/material';
import { useModalRouter } from '@hooks/useModalRouter';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';

import { DrawerMenu } from '@screens/menu';

import { styled } from '@mui/system';
import { Typography } from '@mui/material';
import { DrawerCart } from '@screens/cart/DrawerCart';

const HeaderDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hideBorder',
})<{ hideBorder?: boolean }>(({ hideBorder }) => ({
  height: '64px',
  backgroundColor: '#FFFFFF',
  color: '#414046',
  top: 0,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  borderBottom: '1px solid #EAEAEA',
  boxShadow: hideBorder ? '' : '0px 1px 10px rgba(0, 0, 0, 0.12)',
  position: 'sticky',
  zIndex: 4000,
}));

const BackTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  visibility: 'hidden',
  color: '#414046',
  '@media (min-width: 900px)': {
    visibility: 'visible',
  },
});
const DrawerMenuDiv = styled('div')({
  marginLeft: 20,
});
const TitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '19px',
  lineHeight: '28.5px',
  letterSpacing: '0.15px',
  color: '#414046',
  textAlign: 'center',
});
const LeftDiv = styled('div')({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  left: 0,
});
const RightDiv = styled('div')(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  right: 20,
  [theme.breakpoints.down(380)]: {
    right: 5,
  },
  [theme.breakpoints.down(330)]: {
    right: 0,
  },
}));
interface HeaderProps {
  title: string;
  menuIcon?: boolean;
  backIcon?: boolean;
  cartIcon?: boolean;
  backText?: boolean;
  backFunction?: () => void;
  hideBorder?: boolean;
}
export function Header(props: HeaderProps) {
  const {
    title,
    menuIcon,
    backIcon,
    backText,
    backFunction,
    hideBorder,
    cartIcon,
  } = props;
  const routerModal = useModalRouter();

  return (
    <HeaderDiv hideBorder={hideBorder}>
      <LeftDiv>
        {menuIcon && (
          <DrawerMenuDiv>
            <DrawerMenu menuIconColorChange />
          </DrawerMenuDiv>
        )}
        {backIcon && (
          <IconButton
            onClick={backFunction ? backFunction : routerModal.back}
            color="inherit"
            aria-label="back"
            size="large"
          >
            <ArrowBackIosRoundedIcon />
          </IconButton>
        )}
        {backText && (
          <BackTypography onClick={routerModal.back}>Atrás</BackTypography>
        )}
      </LeftDiv>
      <TitleTypography>{title}</TitleTypography>{' '}
      {cartIcon && (
        <RightDiv>
          <DrawerCart barChange={true} />
        </RightDiv>
      )}
    </HeaderDiv>
  );
}
